import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './ChooseWarehouse.css';
import { Warehouse } from "lucide-react";

export default function ChooseWarehouse() {
    const { allTeams, selectWarehouse } = useAuth();
    const navigate = useNavigate();

    const handleSelect = async (teamId) => {
        await selectWarehouse(teamId);
        // Navigation logic will be handled by useEffect in Login/App or here directly
        // But since we just set the warehouse, let's navigate based on roles
        // We might need to wait for roles to update, but selectWarehouse is async and awaits role fetching

        // We need to check the updated roles. 
        // However, `teamRoles` from usage here might still be stale from previous render cycle 
        // because React state updates are batched/async.
        // It is safer to rely on consistency. 
        // But for simplicity, let's look at the roles we just fetched inside selectWarehouse logic 
        // OR, just navigate to home and let ProtectedRoute handle redirection based on roles.
        navigate('/home');
    };

    if (!allTeams || allTeams.length === 0) {
        return <div className="loading-screen">جاري التحميل...</div>;
    }

    return (
        <div className="choose-warehouse-root" dir="rtl">
            <div className="warehouse-container">
                <h1 className="title">اختر المخزن</h1>
                <p className="subtitle">يرجى اختيار المخزن للمتابعة</p>

                <div className="warehouse-list">
                    {allTeams.map(team => (
                        <div key={team.$id} className="warehouse-card" onClick={() => handleSelect(team.$id)}>
                            <div className="warehouse-icon"><Warehouse size={50} /></div>
                            <div className="warehouse-name">{team.name}</div>
                            {/* <div className="warehouse-id">ID: {team.$id}</div> */}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
